<template>
  <div class="dialog-container" v-loading="isLoading">
    <el-alert class="mb-3" :title="errorMessage" type="error" show-icon v-if="errorMessage"></el-alert>
    <el-row :gutter="18">
      <el-col :span="24">
        <el-form ref="upsertOffice" :model="form" :rules="rules" label-width="30%">
          <el-form-item label="Store #" prop="storeNum">
            <el-input v-model="form.storeNum" placeholder="Store Number" />
          </el-form-item>
          <el-form-item label="IP" prop="ip">
            <el-input v-model="form.ip" placeholder="IP" />
          </el-form-item>
          <el-form-item label="User Id" prop="userId">
            <el-input v-model="form.userId" placeholder="User Id" />
          </el-form-item>
          <el-form-item label="EFIN" prop="efin">
            <el-input v-model="form.efin" placeholder="EFIN" />
          </el-form-item>
          <el-form-item label="Address" prop="address">
            <el-input v-model="form.address" placeholder="Address" />
          </el-form-item>
          <el-form-item label="City" prop="city">
            <el-input v-model="form.city" placeholder="City" />
          </el-form-item>
          <el-form-item label="State" prop="state">
            <us-state-select v-model="form.state"></us-state-select>
          </el-form-item>
          <el-form-item label="Zip" prop="zip">
            <el-input v-model="form.zip" placeholder="Zipcode" />
          </el-form-item>
          <el-form-item label="Phone">
            <el-input v-model="form.phone" placeholder="Phone" />
          </el-form-item>
          <el-form-item label="Brand">
            <el-select v-model="form.brand" placeholder="Brand">
              <el-option v-for="brand in $options.brands" :value="brand" :key="brand"
                :label="prettyNameForBrand(brand)">
                {{ prettyNameForBrand(brand) }}
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row :gutter="18" class="dialog-footer">
      <el-col :span="24" class="align-right">
        <el-button @click="closeDialog">Cancel</el-button>
        <el-button type="primary" @click="upsertOffice">Update Office</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import get from 'lodash/get';
import extend from 'lodash/extend';
import trim from 'lodash/trim';
import api from '@/api';
import Office from '@/model/Office';
import { Required, Integer, IP } from '@/util/formValidators';
import UsStateSelect from '@/components/form-item/USStateSelect.vue';
import { BRAND, BRAND_DESCRIPTION_MAP } from '@/enum/Brand';

export default {
  brands: Object.values(BRAND),
  props: {
    office: {
      type: Object,
      default() {
        return new Office();
      },
    },
  },
  data() {
    return {
      isLoading: false,
      errorMessage: null,
      form: new Office(),
      rules: {
        storeNum: [Required, Integer],
        ip: [IP],
        efin: [Required],
        address: [Required],
        city: [Required],
        state: [Required],
        zip: [Required],
        phone: [Required],
      },
    };
  },
  methods: {
    upsertOffice() {
      this.errorMessage = null;
      this.$refs.upsertOffice.validate((valid) => {
        if (valid) {
          // trim all values
          Object.keys(this.form).forEach((key) => {
            if (typeof this.form[key] === 'string') {
              this.form[key] = trim(this.form[key]);
            }
          });

          const office = extend({}, Office, this.form);

          this.isLoading = true;

          api.office.upsert(office).then((response) => {
            this.$emit('officeUpdated', response.data);
            this.closeDialog();
          }).catch((e) => {
            this.errorMessage = get(e, 'response.data', 'An Error Occurred. Please try again.');
          }).finally(() => {
            this.isLoading = false;
          });
          return true;
        }
        return false;
      });
    },
    prettyNameForBrand(brandId) {
      return BRAND_DESCRIPTION_MAP[brandId];
    },
    closeDialog() {
      this.errorMessage = null;
      this.form = new Office(this.office);
      this.$emit('close');
    },
  },
  watch: {
    office() {
      this.form = new Office(this.office);
    },
  },
  mounted() {
    if (this.office) {
      this.form = new Office(this.office);
    }
  },
  components: {
    UsStateSelect,
  },
};

</script>
